import { render, staticRenderFns } from "./CompanyReinstatementApplications.vue?vue&type=template&id=1b6261d7&scoped=true&"
import script from "./CompanyReinstatementApplications.vue?vue&type=script&lang=js&"
export * from "./CompanyReinstatementApplications.vue?vue&type=script&lang=js&"
import style0 from "./CompanyReinstatementApplications.vue?vue&type=style&index=0&id=1b6261d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6261d7",
  null
  
)

export default component.exports